import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import UIUserSearch from '../../UI/UIUserSearch/UIUserSearch';
import { USER_ROLE_AGENT } from '../../../utils/Config/Constants';
import UIIconButton from '../../UI/UIIconButton';
import Queries from '../../../utils/API/Queries';
import UIOverlayCard from '../../UI/UIOverlayCard';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../utils/Helpers/AppHelper';

class EditListingClientModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedClient: props.listing.client,
			isUpdatingClient: false
		};
	}

	updateClient = async () => {
		const { hideModal, listing } = this.props;
		const { selectedClient, isUpdatingClient } = this.state;

		if (!isUpdatingClient) {
			this.setState({ isUpdatingClient: true });

			const response = await this.props.client.mutate({
				mutation: Queries.UPDATE_LISTING,
				variables: {
					id: listing.id,
					client: selectedClient.id
				}
			});
			const { updateListing } = response['data'];

			if (updateListing) {
				this.props.showSuccessMessage('Successfully updated the client for this listing.');
			} else {
				this.props.showErrorMessage('Error updating the client for this listing.');
			}
			this.setState({ isUpdatingClient: false });
			hideModal();
		}
	};

	render() {
		const { hideModal } = this.props;
		const { selectedClient, isUpdatingClient } = this.state;

		return (
			<UIOverlayCard
				title={'Edit the client for this listing'}
				hideModal={hideModal}
				description={'The client will get all client related notification emails.'}>
				{this.renderSelectedClient()}
				<UIIconButton
					dark
					style={{ marginTop: 16 }}
					isLoading={isUpdatingClient}
					isDisabled={!selectedClient}
					text={'update client'}
					onClick={this.updateClient}
				/>
			</UIOverlayCard>
		);
	}

	renderSelectedClient = () => {
		const { selectedClient } = this.state;

		const style = { margin: '16px 0 0 0' };
		return (
			<UIUserSearch
				emptySetText={'No technicians found with that name'}
				style={style}
				role={USER_ROLE_AGENT}
				selectedUser={selectedClient}
				placeholder={'Client name...'}
				onSelectUser={(selectedClient) => this.setState({ selectedClient })}
			/>
		);
	};
}

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(withApollo(EditListingClientModal)));
